(function () {
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('.oddit-section-ugc-carousel');
    for (var s = 0; s < sections.length; s++) {
      initSection(sections[s]);
    }
  }

  function initSection(section) {
    if (!section || section.dataset.odditUgcInit === 'true') return;
    section.dataset.odditUgcInit = 'true';

    var track = section.querySelector('.oddit-section-ugc-carousel__track');
    var prevBtn = section.querySelector('.oddit-section-ugc-carousel__arrow--prev');
    var nextBtn = section.querySelector('.oddit-section-ugc-carousel__arrow--next');
    var dotsNav = section.querySelector('.oddit-section-ugc-carousel__dots');

    if (!track) return;

    var originals = Array.prototype.slice.call(
      track.querySelectorAll('.oddit-section-ugc-carousel__card')
    );
    var n = originals.length;
    if (n === 0) return;

    // Build one pagination dot per card so the count always matches.
    var dots = [];
    if (dotsNav) {
      dotsNav.innerHTML = '';
      for (var dotI = 0; dotI < n; dotI++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'oddit-section-ugc-carousel__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (dotI + 1));
        if (dotI === 0) {
          dot.classList.add('oddit-section-ugc-carousel__dot--active');
          dot.setAttribute('aria-current', 'true');
        }
        dotsNav.appendChild(dot);
        dots.push(dot);
      }
    }

    var currentDom = n > 1 ? n : 0; // DOM index of the centred card
    var isAdjusting = false;        // true during an instant loop reposition
    var dragActive = false;
    var scrollRaf = null;
    var settleTimer = null;
    var willChangeTimer = null;

    // GWT-22: hint the compositor only while actively scrolling, then release
    // it at rest so we don't keep an extra layer around permanently.
    function markScrolling() {
      if (track.style.willChange !== 'transform') {
        track.style.willChange = 'transform';
      }
      window.clearTimeout(willChangeTimer);
      willChangeTimer = window.setTimeout(function () {
        track.style.willChange = '';
      }, 200);
    }

    // --- Build a seamless loop: clone a full set before and after the originals.
    // Layout becomes: [clones][originals][clones] so the centered card always has
    // identical neighbours on both sides and scrollLeft can wrap by one set-width.
    if (n > 1) {
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      for (var c = 0; c < n; c++) {
        before.appendChild(sanitizeClone(originals[c].cloneNode(true)));
        after.appendChild(sanitizeClone(originals[c].cloneNode(true)));
      }
      track.insertBefore(before, originals[0]);
      track.appendChild(after);
    }

    var allCards = track.querySelectorAll('.oddit-section-ugc-carousel__card');

    // Wire video behaviour on every card, clones included (they are real,
    // visible copies in the seamless loop).
    var videoCards = track.querySelectorAll('.oddit-section-ugc-carousel__card--video');
    for (var vc = 0; vc < videoCards.length; vc++) {
      setupVideoCard(videoCards[vc]);
    }

    // Hover: muted preview looping the first 3 seconds.
    // Click: full playback with native controls + sound; returns to poster on end.
    function setupVideoCard(card) {
      if (card.dataset.odditVideoInit === 'true') return;
      card.dataset.odditVideoInit = 'true';

      var video = card.querySelector('.oddit-section-ugc-carousel__video');
      var media = card.querySelector('.oddit-section-ugc-carousel__card-media');
      var playBtn = card.querySelector('.oddit-section-ugc-carousel__play');
      if (!video) return;

      var PREVIEW_SECONDS = 3;
      var isHover = false;

      function state() {
        return card.getAttribute('data-ugc-state');
      }
      function setState(s) {
        card.setAttribute('data-ugc-state', s);
      }
      function rewind() {
        try { video.currentTime = 0; } catch (e) {}
      }
      function safePlay() {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }

      function startPreview() {
        if (state() === 'playing' || prefersReducedMotion) return;
        setState('preview');
        video.controls = false;
        video.muted = true;
        if (video.currentTime >= PREVIEW_SECONDS) rewind();
        safePlay();
      }

      function stopPreview() {
        if (state() === 'playing') return;
        video.pause();
        rewind();
        setState('idle');
      }

      function startPlayback() {
        setState('playing');
        video.controls = true;
        video.muted = false;
        rewind();
        safePlay();
      }

      function returnToPoster() {
        video.pause();
        video.controls = false;
        video.muted = true;
        rewind();
        setState('idle');
        if (isHover) startPreview();
      }

      function activate(e) {
        if (state() === 'playing') return; // let native controls handle it
        if (e) e.preventDefault();
        startPlayback();
      }

      card.addEventListener('mouseenter', function () {
        isHover = true;
        startPreview();
      });
      card.addEventListener('mouseleave', function () {
        isHover = false;
        stopPreview();
      });
      if (playBtn) playBtn.addEventListener('click', activate);
      if (media) media.addEventListener('click', activate);

      // Loop only the first 3 seconds while previewing (not during full playback).
      video.addEventListener('timeupdate', function () {
        if (state() === 'preview' && video.currentTime >= PREVIEW_SECONDS) {
          rewind();
        }
      });
      video.addEventListener('ended', returnToPoster);
    }

    function sanitizeClone(node) {
      node.setAttribute('aria-hidden', 'true');
      node.setAttribute('data-oddit-clone', 'true');
      // Strip scroll-reveal so clones are visible immediately (the reveal
      // observer never sees nodes added after init).
      node.classList.remove('oddit-reveal', 'oddit-entrance', 'oddit-section-active');
      var classes = node.className.split(/\s+/).filter(function (cls) {
        return cls.indexOf('oddit-reveal') !== 0;
      });
      node.className = classes.join(' ');
      node.style.opacity = '';
      node.style.transform = '';
      // Keep cloned interactive elements out of the tab order.
      var focusables = node.querySelectorAll('a, button, [tabindex]');
      for (var f = 0; f < focusables.length; f++) {
        focusables[f].setAttribute('tabindex', '-1');
      }
      return node;
    }

    function centerOffset() {
      var cardW = allCards[0] ? allCards[0].offsetWidth : 0;
      return (track.clientWidth - cardW) / 2;
    }

    // scrollLeft that centres the card at a given DOM index in the viewport.
    function posOf(domIndex) {
      if (!allCards[domIndex]) return 0;
      return allCards[domIndex].offsetLeft - centerOffset();
    }

    // DOM index of the card currently nearest the viewport centre.
    function nearestDom() {
      var center = track.scrollLeft + centerOffset();
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < allCards.length; i++) {
        var dist = Math.abs(allCards[i].offsetLeft - center);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function logicalIndex(domIndex) {
      if (n < 2) return 0;
      return ((domIndex - n) % n + n) % n;
    }

    // Set scrollLeft instantly with snap + smooth disabled, then restore them a
    // frame later. The loop reposition (clone → matching real slide) must never
    // animate or be re-snapped by the browser, or it becomes visible. Re-enabling
    // snap a frame AFTER the position is set is what stops the snap engine from
    // yanking the jump — the bug that plagued the old live-wrap approach.
    function setScrollInstant(pos) {
      isAdjusting = true;
      var snap = track.style.scrollSnapType;
      var behavior = track.style.scrollBehavior;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = pos;
      requestAnimationFrame(function () {
        track.style.scrollSnapType = snap;
        track.style.scrollBehavior = behavior;
        requestAnimationFrame(function () {
          isAdjusting = false;
        });
      });
    }

    function updateDots(activeOriginal) {
      if (!dots || !dots.length) return;
      for (var i = 0; i < dots.length; i++) {
        if (i === activeOriginal) {
          dots[i].classList.add('oddit-section-ugc-carousel__dot--active');
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].classList.remove('oddit-section-ugc-carousel__dot--active');
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    function updateActiveDot() {
      updateDots(logicalIndex(currentDom));
    }

    // Smooth-scroll to centre a DOM index. The settle handler later normalises a
    // clone index back onto its matching real slide once motion stops.
    function scrollToDom(domIndex) {
      currentDom = domIndex;
      track.scrollTo({ left: posOf(domIndex), behavior: 'smooth' });
      updateActiveDot();
    }

    // Once scrolling settles, if we're parked on a clone jump instantly to the
    // matching real slide. Content is identical so the jump is invisible — and
    // because this only runs at REST (never mid-scroll/drag), nothing fights it.
    // This is the key difference from the old design, which wrapped continuously
    // during motion and produced the visible shift at the clone boundary.
    function normalize() {
      if (isAdjusting || dragActive || n < 2) {
        updateActiveDot();
        return;
      }
      var nearest = nearestDom();
      currentDom = nearest;
      var normalized = nearest;
      if (nearest < n) normalized = nearest + n;
      else if (nearest >= 2 * n) normalized = nearest - n;
      if (normalized !== nearest) {
        currentDom = normalized;
        setScrollInstant(posOf(normalized));
      }
      updateActiveDot();
    }

    var onPrev = function () { scrollToDom(currentDom - 1); };
    var onNext = function () { scrollToDom(currentDom + 1); };
    if (prevBtn) prevBtn.addEventListener('click', onPrev);
    if (nextBtn) nextBtn.addEventListener('click', onNext);

    for (var d = 0; d < dots.length; d++) {
      (function (dotIdx) {
        dots[dotIdx].addEventListener('click', function () {
          scrollToDom(n > 1 ? n + dotIdx : dotIdx);
        });
      })(d);
    }

    // Live dot feedback while scrolling; coalesced to one layout read per frame.
    var onScroll = function () {
      if (isAdjusting) return;
      markScrolling();
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = null;
        if (isAdjusting) return;
        currentDom = nearestDom();
        updateActiveDot();
      });
    };
    track.addEventListener('scroll', onScroll, { passive: true });

    // Settle detection → normalise the loop, but only after motion has stopped.
    var hasScrollEnd = 'onscrollend' in window;
    var onScrollEnd = function () { normalize(); };
    var onScrollSettle = function () {
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(normalize, 140);
    };
    if (hasScrollEnd) {
      track.addEventListener('scrollend', onScrollEnd);
    } else {
      track.addEventListener('scroll', onScrollSettle, { passive: true });
    }

    // --- Desktop drag-to-scroll (mouse only; touch keeps native scrolling) ---
    var dragStartX = 0;
    var dragLastX = 0;
    var dragMoved = false;

    var DRAG_THRESHOLD = 10;

    var onPointerDown = function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (typeof e.button === 'number' && e.button !== 0) return;
      if (track.scrollWidth <= track.clientWidth) return;
      dragActive = true;
      dragMoved = false;
      dragStartX = e.clientX;
      dragLastX = e.clientX;
      track.classList.add('is-dragging');
    };

    var onPointerMove = function (e) {
      if (!dragActive) return;
      var dx = e.clientX - dragLastX;
      dragLastX = e.clientX;
      if (Math.abs(e.clientX - dragStartX) > DRAG_THRESHOLD) dragMoved = true;
      // Just move; the loop is normalised once the drag ends (rest-only), so
      // there is no mid-drag reposition to glitch across the seam.
      track.scrollLeft -= dx;
      markScrolling();
    };

    var onPointerUp = function () {
      if (!dragActive) return;
      dragActive = false;
      track.classList.remove('is-dragging');
      if (dragMoved) {
        scrollToDom(nearestDom()); // settle on the nearest card
        window.setTimeout(function () {
          dragMoved = false;
        }, 0);
      }
    };

    // A drag ends in a click; swallow it so cards don't trigger (e.g. video play).
    var onDragClick = function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    };

    var onDragStart = function (e) { e.preventDefault(); };

    track.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);
    window.addEventListener('pointercancel', onPointerUp);
    track.addEventListener('click', onDragClick, true);
    track.addEventListener('dragstart', onDragStart);

    // On resize, keep the current card centred (widths change per breakpoint).
    var resizeTimer = null;
    var onResize = function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        setScrollInstant(posOf(currentDom));
        updateActiveDot();
      }, 120);
    };
    window.addEventListener('resize', onResize);

    // Store teardown so shopify:section:unload can remove listeners cleanly.
    section._odditUgcTeardown = function () {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', onPointerUp);
      window.removeEventListener('pointercancel', onPointerUp);
      window.clearTimeout(resizeTimer);
      window.clearTimeout(settleTimer);
      window.clearTimeout(willChangeTimer);
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      track.style.willChange = '';
    };

    // Initial placement: centre the first real card.
    updateActiveDot();
    setScrollInstant(posOf(currentDom));
    // Re-align once more after fonts/images may have shifted widths.
    requestAnimationFrame(function () {
      setScrollInstant(posOf(currentDom));
    });
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root) return;
    if (root.classList && root.classList.contains('oddit-section-ugc-carousel')) {
      initSection(root);
    } else {
      initAll(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target;
    if (!root) return;
    var sections = root.classList && root.classList.contains('oddit-section-ugc-carousel')
      ? [root]
      : root.querySelectorAll('.oddit-section-ugc-carousel');
    for (var i = 0; i < sections.length; i++) {
      if (typeof sections[i]._odditUgcTeardown === 'function') {
        sections[i]._odditUgcTeardown();
      }
    }
  });
})();
